import {Box, ButtonBase, Typography} from '@mui/material';
import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {useNavigate} from 'react-router-dom';
import {sanitizeURL} from '../../../../Util/sanitizeURL';

type Props = {
  title: string;
  miniToolsId: string;
  poctoolsId: string;
};

export default function POCToolMiniTool(props: Props) {
  const {title, miniToolsId, poctoolsId} = props;
  const navigate = useNavigate();

  const encodedToolName = sanitizeURL(title);

  return (
    <ButtonBase
      onClick={() =>
        navigate(`/MiniTools/${encodedToolName}/${poctoolsId}/${miniToolsId}/`)
      }
      style={styles.container}>
      <Box
        display="flex"
        padding={'20px 10px'}
        color={'#1976D2'}
        justifyContent="space-between"
        width={'100%'}
        borderBottom={1}
        borderColor={'#DDDDDD'}>
        <Typography
          color="inherit"
          variant="body1"
          fontSize={20}
          fontWeight={700}>
          {title}
        </Typography>
        <ArrowForwardIcon color={'inherit'} />
      </Box>
    </ButtonBase>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
};
